import { all, call, put, select, take } from 'redux-saga/effects';

import { CHECK_MOBILE_SETTING } from './actions';
import { SAVE_IS_MOBILE } from 'Reducers/compModels';


function* mobile() {
  while (true) {
    const { data } = yield take(CHECK_MOBILE_SETTING);

    const { isMobile } = yield select(state => {
      return {
        isMobile: state.reader.isMobile
      };
    });

    if (isMobile && innerWidth > 480) {
      yield put({ type: SAVE_IS_MOBILE });
    }

    if (!isMobile && innerWidth <= 480) {
      yield put({ type: SAVE_IS_MOBILE });
    }
  }
}


export default mobile;
